import { useEffect } from 'react'
import { useAppDispatch } from '@hooks/reduxHooks'
import { productOrderService } from '@services/ProductOrderService'
import { upsertProductOrder } from '@state/reducers/productOrderReducer'

export function useProductOrderSSE() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const unsubscribe = productOrderService.subscribeToEvents((updatedOrder) => {
      dispatch(upsertProductOrder(updatedOrder))
    })
    return unsubscribe
  }, [dispatch])
}
